import { useTranslation } from "react-i18next";

import usePipelineStatusTranslations from "./usePipelineStatusTranslations";

export default function useDistributionsRefinements({ publisher }) {
	const { t } = useTranslation();

	const pipelineStatusTranslations = usePipelineStatusTranslations();

	return [
		{
			header: t("status", "Status"),
			attribute: "status",
			renderItem: ({ label }) => pipelineStatusTranslations[label],
		},
		{
			header: t("channel", "Channel"),
			attribute: "channel.name",
			searchable: true,
		},
		!publisher && {
			header: t("publisher", "Publisher"),
			attribute: "publisher.name",
			searchable: true,
		},
		{
			header: t("articleType", "Article type"),
			attribute: "article.type",
		},
		{
			header: t("deliveryMeta", "Delivery metadata"),
			attribute: "delivery.metadata",
		},
		{
			header: t("deliveryArtifact", "Delivery artifact"),
			attribute: "delivery.artifact",
		},
	].filter(Boolean);
}
